<div class="inline-block relative">
  <h2 *ngIf="!percent">
    <span *ngIf="hasScore">{{score}}</span>
    <span *ngIf="!hasScore">?</span>
  </h2>

  <h4 *ngIf="percent">
    <span *ngIf="hasScore">
      <span>
        <fa-icon icon="heart" size="xs"></fa-icon> {{health}}
      </span>
      &nbsp;
      <span [class]="armourClass">
        {{armour}} <fa-icon icon="shield" size="xs"></fa-icon>
      </span>
    </span>
    <span *ngIf="!hasScore">?</span>
  </h4>

  <div @fade *ngIf="scoreDelta" class="absolute scoreDelta">
    <h4 [class]="colorClass">{{formattedDelta}}</h4>
  </div>
</div>
